(function(factory) {
    if (typeof define === "function" && define.amd) {
        // AMD
        define(["jquery", "moment", "datatables.net", "datatables-editor"], factory);
    } else if (typeof exports === "object") {
        // Node / CommonJS
        module.exports = function($, dt) {
        if (!$) {
            $ = require("jquery");
        }
        factory($, dt || $.fn.dataTable || require("datatables.net"));
        };
    } else if (jQuery) {
        // Browser standard
        factory(jQuery, moment);
    }
})(function($, DataTable) {
    $.fn.dataTable.moment = function ( format, locale ) {
        var types = $.fn.dataTable.ext.type;

        // Add type detection
        types.detect.unshift( function ( d ) {
            // Strip HTML tags if possible
            if ( d && d.replace ) {
                d = d.replace(/<.*?>/g, '');
            }

            // Null and empty values are acceptable
            if ( d === '' || d === null ) {
                return 'moment-'+format;
            }

            return moment( d, format, locale, true ).isValid() ?
                'moment-'+format :
                null;
        } );

        // Add sorting method - use an integer for the sorting
        types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
            if ( d && d.replace ) {
                d = d.replace(/<.*?>/g, '');
            }
            return d === '' || d === null ?
                -Infinity :
                parseInt( moment( d, format, locale, true ).format( 'x' ), 10 );
        };
    };
});



// WEBPACK FOOTER //
// ./src/assets/plugins/datatables/datetime-moment.js